import script from "./ProcEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ProcEditPage.vue?vue&type=style&index=0&id=4816f476&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4816f476"]])

export default __exports__